// ItemMenus.js
class ItemMenus {
    constructor({nome, navegarPara, icone="", permissao="", SoLogado=false, logout=false, login=false}) {
        this.nome = nome;
        this.icone = icone;
        this.permissao=permissao;
        this.navegarPara=navegarPara;
        this.SoLogado =  SoLogado;
        this.logout =  logout;
        this.login =  login;
    }
  }
  
  export  {ItemMenus}; 
  